var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadNavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 152,
    viewBox: "0 0 230 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download - navy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325720",
    d: "M166.286 35.8936V44.9546L79.7773 66.3817C77.722 66.8908 76.2564 68.6056 76.1809 70.7295C75.8748 79.3433 75.0213 103.076 73.8779 132.504C73.3052 147.244 59.0029 147.236 58.4323 132.496C56.8019 90.3783 55.5246 54.6466 55.1241 43.3355C55.0447 41.0928 56.5429 39.2165 58.7115 38.6722L91.8949 30.3435C93.2681 29.9988 94.7229 30.2889 95.8607 31.1342L106.193 38.8106C107.885 40.0677 110.046 40.5067 112.092 40.009L157.51 28.9622C161.98 27.8747 166.286 31.2752 166.286 35.8936Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325721",
    d: "M182.004 109.613L69.4961 142.425C69.6655 142.375 73.936 140.345 73.936 127.567L76.479 70.2629C76.5508 68.6469 77.6756 67.2699 79.2448 66.8771L180.092 41.6348C182.401 41.057 184.637 42.8029 184.637 45.1828V106.102C184.637 107.728 183.565 109.158 182.004 109.613Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325722",
    d: "M121.689 94.0635V57.4259L139.744 53.0547V90.2003L148.032 88.4174L130.864 110.11L112.217 96.1437L121.689 94.0635Z",
    fill: "#73DC78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325723",
    opacity: 0.2,
    d: "M219.4 136.732H199.65H148.571C146.074 135.853 137.933 132.385 138.356 124.21C139.037 111.029 154.702 113.665 153.339 112.347C153.793 111.029 153.464 105.464 158.106 103.78C162.749 102.095 167.232 103.78 169.684 105.757C170.235 106.202 169.684 93.2349 180.581 91.9168C194.883 90.1868 195.479 104.439 196.245 103.78C198.288 102.022 201.693 98.1524 209.185 99.8253C217.357 101.65 218.265 109.491 217.357 113.006C215.995 113.665 226.892 112.347 228.935 122.892C230.467 130.801 223.487 134.755 219.4 136.732Z",
    fill: "#8080A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325726",
    d: "M63.0781 62.422L92.9339 35.5703",
    stroke: "#00004B",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325727",
    d: "M83.6035 49.3083L93.5554 40.5659",
    stroke: "#00004B",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325729",
    d: "M80.4941 52.4301L81.1161 51.8057",
    stroke: "#00004B",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325728",
    d: "M62.457 56.8015L72.4089 48.0591",
    stroke: "#00004B",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNavy);
export default __webpack_public_path__ + "static/media/Download - navy.0db61e1872fce4fae2d0e5f535d11ac2.svg";
export { ForwardRef as ReactComponent };